/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menufileundecodable2Inputs */

const en_menufileundecodable2 = /** @type {(inputs: Menufileundecodable2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} cannot be opened in the browser. Please save it as a JPEG.`)
};

const de_menufileundecodable2 = /** @type {(inputs: Menufileundecodable2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} lässt sich im Browser nicht öffnen. Bitte als JPEG speichern.`)
};

/**
* | output |
* | --- |
* | "{name} cannot be opened in the browser. Please save it as a JPEG." |
*
* @param {Menufileundecodable2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufileundecodable2 = /** @type {((inputs: Menufileundecodable2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufileundecodable2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufileundecodable2(inputs)
	return de_menufileundecodable2(inputs)
});
export { menufileundecodable2 as "menuFileUndecodable" }